import React, {Component} from 'react';
import {ReactSVG} from "react-svg";
import {images} from "assets/img/dashboard/investments/investments";
import {app} from "app/app";
import {Spinner} from 'reactstrap';
import {MainButton} from "components/common/MainButton";
import {roundWithTwoDecimals} from "buenLib/utils/roundWithTwoDecimals"
import {Modal} from "components/common/Modal";
import {MoneyField} from "buenLib/components/MoneyField";
import {Currency} from "buenLib/domain/Currency";
import "assets/sass/dashboard/investments/Main.scss"
import { AppContext } from 'app/state/AppContext';
import { InputCheckbox } from 'components/common/InputCheckbox';

class InvestmentsController extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
        this.state = {
            loadingData: true,
            makingOperation: false,
            currency: Currency.DAI,
            activeTab: Currency.DAI,
            isInvesting: undefined,
            annualProfitability: undefined,
            monthlyProfitability: undefined,
            aggregatedInterests: undefined,
            hasReadTermsAndConditions: false,
        };

        this.handleInvestmentStatusResponse = this.handleInvestmentStatusResponse.bind(this);
        this.handleAccountBalanceResponse = this.handleAccountBalanceResponse.bind(this);
        this.handleChangeInvestmentStatusResponse = this.handleChangeInvestmentStatusResponse.bind(this);
        this.startInvesting = this.startInvesting.bind(this);
        this.stopInvesting = this.stopInvesting.bind(this);
        this.renderInvestmentStatus = this.renderInvestmentStatus.bind(this);
        this.renderMoneyStatus = this.renderMoneyStatus.bind(this);
        this.renderAggregatedInterests = this.renderAggregatedInterests.bind(this);
        this.renderInvestmentStatus = this.renderInvestmentStatus.bind(this);
        this.renderStartInvestingModal = this.renderStartInvestingModal.bind(this);
        this.renderStopInvestingModal = this.renderStopInvestingModal.bind(this);
        this.toggleTermsAndConditionsReadStatus = this.toggleTermsAndConditionsReadStatus.bind(this);
        this._renderStopInvestingButtonInModal = this._renderStopInvestingButtonInModal.bind(this);
        this._renderStartInvestingButtonInModal = this._renderStartInvestingButtonInModal.bind(this);
        this._renderContinueInvestingButtonInModal = this._renderContinueInvestingButtonInModal.bind(this);
        this._renderLaterButtonInModal = this._renderLaterButtonInModal.bind(this);
    }

    componentDidMount() {
        this.getInvestmentAndAccountBalanceStatus();
    }

    getInvestmentAndAccountBalanceStatus() {
        this.setState({loadingData: true}, () => app.apiClient().getInvestmentStatus(this.handleInvestmentStatusResponse));
    }

    getAccountBalance() {
        this.setState({loadingData: true}, () => app.apiClient().getAccountBalance(this.handleAccountBalanceResponse));
    }

    handleInvestmentStatusResponse(response) {
        this.setState({
            isInvesting: response.isInvesting(),
            annualProfitability: response.annualProfitability(),
            monthlyProfitability: response.monthlyProfitability(),
            aggregatedInterests: response.aggregatedInterests(),
        }, this.getAccountBalance);
    }

    handleAccountBalanceResponse(response) {
        this.setState({
            accountBalance: response.content()[this.state.currency],
            loadingData: false,
        });
    }

    handleChangeInvestmentStatusResponse(response) {
        if (!response.hasError()) {
            let isInvesting = response.content().is_investing;
            app.currentUser().markNewInvestmentStatusIn(this.state.currency, isInvesting);
            app.session().saveUser();
            this.setState({makingOperation: false, hasReadTermsAndConditions: false}, this.getInvestmentAndAccountBalanceStatus);
        }
    }

    toggleTermsAndConditionsReadStatus() {
        this.setState(prevState => {
            return {
                ...prevState,
                hasReadTermsAndConditions: !prevState.hasReadTermsAndConditions
            };
        });
    }

    startInvesting() {
        this.setState({makingOperation: true}, () => app.apiClient().startInvesting(this.handleChangeInvestmentStatusResponse));
    }

    stopInvesting() {
        this.setState({makingOperation: true}, () => app.apiClient().stopInvesting(this.handleChangeInvestmentStatusResponse));
    }

    changeToTab(tab) {
        this.setState({activeTab: tab});
    }

    annualProfitability() {
        return roundWithTwoDecimals(parseFloat(this.state.annualProfitability))
    }

    monthlyProfitability() {
        return roundWithTwoDecimals(parseFloat(this.state.monthlyProfitability))
    }

    renderMoneyStatus() {
        return (
            <div className="data">
                <div className="data-label">Dai invertidos</div>
                <div className={`money ${this.state.currency} ${!this.state.isInvesting ? "-off" : ""}`}>
                    <ReactSVG src={images[this.state.currency]}/><MoneyField value={this.state.accountBalance}
                                                                             currency={this.state.currency}/>
                </div>
            </div>
        )
    }

    renderAggregatedInterests() {
        return (
            <div className="data">
                <div className="data-label">Tu ganancia hasta ahora</div>
                <div
                    className={`money ${this.state.currency} ${!this.state.isInvesting ? "-off" : this.state.aggregatedInterests >= 0 ? "up" : "down"}`}>
                    <ReactSVG src={images[this.state.currency]}/><MoneyField value={this.state.aggregatedInterests}
                                                                             currency={this.state.currency}/>
                </div>
            </div>
        )
    }

    renderInvestmentData() {
        return (
            <div className="investments-data-block" key="data">
                {this.renderMoneyStatus()}
                {this.renderAggregatedInterests()}
                <div className="data">
                    <div className="data-label">Rendimiento anual</div>
                    <div className={`money ${this.annualProfitability() >= 0 ? "up" : "down"}`}>
                        <ReactSVG src={images.money}/>{this.annualProfitability()}%
                    </div>
                </div>
            </div>
        )
    }

    startInvestingButton() {
        if (!this.state.isInvesting) {
            return <MainButton styleName="cta" text="Comenzar a invertir"/>
        }
    }

    stopInvestingButton() {
        if (this.state.isInvesting) {
            return <MainButton styleName="cta" text="Dejar de invertir"/>
        }
    }

    renderInvestmentStatus() {
        let investmentStatusText = this.state.isInvesting ? "¡Invirtiendo!" : "No estás invirtiendo";
        return <p className={`status ${this.state.isInvesting ? "-on" : ""}`}>{investmentStatusText}</p>
    }

    renderActions() {
        return (
            <div className="investments-actions" key="actions">
                <div>
                    <p className="status-label">Estado de inversión:</p>
                    {this.renderInvestmentStatus()}
                </div>
                <div>
                    {this.renderModalForInvestmentsExplanation()}
                    {this.renderStartInvestingModal()}
                    {this.renderStopInvestingModal()}
                </div>
            </div>
        )
    }

    renderModalForInvestmentsExplanation() {
        return (
            <a
                className="link-btn"
                href="https://www.buenbit.com/terminos-y-condiciones-de-inversiones"
                target="_blank"
                rel="noopener noreferrer"
            >
                ¿Cómo funciona?
            </a>
        );
    }

    renderStartInvestingModal() {
        return <Modal type={Modal.MODAL_TYPES.startInvestment} trigger={this.startInvestingButton()}
                      canBeDismissed={false} title="¿Estás seguro de que querés empezar a invertir?">
            <div className="modal-box">
                <div className="terms-checkbox-container">
                    <InputCheckbox
                        handleChange={this.toggleTermsAndConditionsReadStatus}
                        label={
                            <span>
                                He leído y acepto los&nbsp;
                                <a
                                    className="new-terms-anchor"
                                    href="https://buenbit.com/es-AR/terminos-y-condiciones-inversiones/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >Términos y condiciones</a>
                            </span>
                        }
                    />
                </div>
                <div className="modal-actions-container">
                    {this._renderLaterButtonInModal()}
                    {this._renderStartInvestingButtonInModal()}
                </div>
            </div>
        </Modal>;
    }

    renderStopInvestingModal() {
        return <Modal type={Modal.MODAL_TYPES.confirm}
                      trigger={this.stopInvestingButton()}
                      canBeDismissed={false} title="¿Estás seguro de que querés dejar de invertir?">
            <div className="modal-box">
                {this._renderContinueInvestingButtonInModal()}
                {this._renderStopInvestingButtonInModal()}
            </div>
        </Modal>;
    }

    _renderStopInvestingButtonInModal() {
        return <MainButton onClick={this.stopInvesting}
                           loading={this.state.makingOperation}
                           styleName="primary" text="Dejar de invertir"/>;
    }

    _renderStartInvestingButtonInModal() {
        return (
            <MainButton
                onClick={this.startInvesting}
                loading={this.state.makingOperation}
                disabled={!this.state.hasReadTermsAndConditions}
                className={`start-investing-button ${!this.state.hasReadTermsAndConditions && 'disabled'}`}
                styleName="primary" text="Comenzar a invertir"
            />
        );
    }

    _renderContinueInvestingButtonInModal() {
        return <MainButton data-action={Modal.CLOSE_MODAL_ACTION}
                           styleName="secondary" text="Seguir invirtiendo"/>;
    }

    _renderLaterButtonInModal() {
        return <MainButton data-action={Modal.CLOSE_MODAL_ACTION} className="close-modal-button"
                           styleName="secondary" text="En otro momento"/>;
    }

    renderSafeContent() {
        return (
            [this.renderActions(), this.renderInvestmentData()]
        )
    }

    renderContent() {
        if (this.state.loadingData) {
            return <Spinner className="spinner-color"/>;
        } else {
            if (app.currentUser().isSafe()) {
                return this.renderSafeContent()
            } else {
                return <div>
                    <p>
                        [ ! ] No podés invertir hasta finalizar la verificación de tu cuenta
                    </p>
                </div>
            }
        }
    }

    render() {
        const { getCurrencyInstance } = this.context;
        const currencyInstance = getCurrencyInstance(this.state.currency);
        const currencyCode = currencyInstance ? currencyInstance.code()
            : Currency.prettyCurrencyFor(Currency.DAI);

        return (
            <main>
                <h5 className="dashboard-title">Mis inversiones</h5>
                <div className="investments-chart">
                    <div className="investments-main">
                        <div className="investments-tabs">
                            <button className={"tab " + (this.state.activeTab === this.state.currency ? "active" : '')}
                                    onClick={() => this.changeToTab(this.state.currency)}>
                                {currencyCode}
                            </button>
                        </div>
                        <div className="investments-content">
                            {this.renderContent()}
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}

export default InvestmentsController;
